module.exports = __webpack_public_path__ + "img/arrow.2ffd6ebb.svg";